<div class="container-fluid">
  <div class="d-flex gap-1 mt-2">

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>&nbsp;

    <mat-form-field appearance="outline">
      <mat-label>Centres</mat-label>
      <mat-select [formControl]="centreControl" (selectionChange)="onCentreSelect($event)">
        <mat-option [value]="all">All Centres</mat-option>
        <mat-option *ngFor="let c of (_centres$ | async)" [value]="c">{{ c.centreName }}</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Submitted By</mat-label>
      <mat-select [(ngModel)]="submittedBy" (selectionChange)="onCounsellorSelect($event)">
        <mat-option [value]="null">All Counsellors</mat-option>
        <mat-option *ngFor="let e of counsellors$ | async" [value]="e.userName">{{ e.userName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-mini-fab (click)="search()" color="accent">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab (click)="clearAll()" color="accent">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Counselling Group Session</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                 (keyup)='applyfilters()' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li class="me-2">
          <button permission="Group Sessions"
                  [permissionTypes]="[PermissionType.ALL,PermissionType.ADD]"
                  mat-mini-fab color="primary"
                  (click)="openGroupSessionDialog()">
            <mat-icon class="col-white">add</mat-icon>
          </button>
        </li>

       <li>
         <button
           mat-mini-fab
           color="accent"
           (click)="downloadExcel()">
           <mat-icon>download</mat-icon>
         </button>
        </li>
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading...</mat-progress-bar>
    <table mat-table [dataSource]="dataSource" class="table" matSort>

      <ng-container matColumnDef="sr.no">
        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
        <td mat-cell *matCellDef="let element; let i=index" >
          {{ i+1}}
        </td>
      </ng-container>

      <!-- Date of Session Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Session</th>
        <td mat-cell *matCellDef="let element" class="truncate-text">
          {{ (element.date).toDate() | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <!-- Children Names Column -->
      <ng-container matColumnDef="childrenNames">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Names</th>
        <td mat-cell *matCellDef="let element" class="truncate-text" matTooltipPosition="above"
            [matTooltip]="element.childrenNames">
          {{ element.childrenNames }}
        </td>
      </ng-container>

      <!-- Centres Column -->
      <ng-container matColumnDef="centres">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centres</th>
        <td mat-cell *matCellDef="let element" class="truncate-text" matTooltipPosition="above"
            [matTooltip]="getCenterNames(element.centres)">
          {{ getCenterNames(element.centres) }}
        </td>
      </ng-container>

      <!-- Topics Covered Column -->
      <ng-container matColumnDef="topicsCovered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Topics Covered</th>
        <td mat-cell *matCellDef="let element" class="truncate-text" matTooltipPosition="above"
            [matTooltip]="getTopicsCovered(element.topicsCovered)">
          {{ getTopicsCovered(element.topicsCovered) }}
        </td>
      </ng-container>

      <!-- Submitted By Column -->
      <ng-container matColumnDef="submittedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted By</th>
        <td mat-cell *matCellDef="let element" class="truncate-text" matTooltipPosition="above"
            [matTooltip]="element?.submittedBy">
          {{ element?.submittedBy }}
        </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At</th>
        <td mat-cell *matCellDef="let element" class="truncate-text">
          <span *ngIf="element.createdAt">{{ element?.createdAt | date:'dd/MM/yyyy' }}</span>
        </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Action</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex">
            <button
              permission="Group Sessions"
              [permissionTypes]="[PermissionType.ALL,PermissionType.ADD,PermissionType.VIEW]"
              mat-icon-button color="accent" matTooltip="View" (click)="viewDialog(element)">
              <mat-icon>remove_red_eye</mat-icon>
            </button>
            <button
              permission="Group Sessions"
              [permissionTypes]="[PermissionType.ALL,PermissionType.ADD, PermissionType.EDIT]"
              *ngIf="editAccess(element)"
              mat-icon-button color="primary" matTooltip="Edit" (click)="viewEdit(element)">
              <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="this.userData=='Krisha Shah'" mat-icon-button color="warn" matTooltip="Delete"
                    (click)="delete(element)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


    <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" showFirstLastButtons
                   aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
</div>
